/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteEnvironmentSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteEnvironmentRequest = {
  /**
   * The slug of the environment to delete
   */
  slug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteEnvironmentSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteEnvironmentSecurity$outboundSchema: z.ZodMiniType<
  DeleteEnvironmentSecurity$Outbound,
  DeleteEnvironmentSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteEnvironmentSecurityToJSON(
  deleteEnvironmentSecurity: DeleteEnvironmentSecurity,
): string {
  return JSON.stringify(
    DeleteEnvironmentSecurity$outboundSchema.parse(deleteEnvironmentSecurity),
  );
}

/** @internal */
export type DeleteEnvironmentRequest$Outbound = {
  slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteEnvironmentRequest$outboundSchema: z.ZodMiniType<
  DeleteEnvironmentRequest$Outbound,
  DeleteEnvironmentRequest
> = z.pipe(
  z.object({
    slug: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteEnvironmentRequestToJSON(
  deleteEnvironmentRequest: DeleteEnvironmentRequest,
): string {
  return JSON.stringify(
    DeleteEnvironmentRequest$outboundSchema.parse(deleteEnvironmentRequest),
  );
}
